export interface IPermission {
    key: string,
    name: string
}

export interface IPermissionGroup {
    name: string,
    permissions: IPermission[]
}
export const PERMISSIONS: {
    [key: string]: IPermission;
  } = { 
    ADMIN: {
        key: "Admin",
        name: "Quản trị viên"
    },
    ACCOUNT_VIEW: {
        key: "Account.View",
        name: "Xem danh sách"
    },
    ACCOUNT_ADD: {
        key: "Account.Add",
        name: "Thêm mới"
    },
    ACCOUNT_EDIT: {
        key: "Account.Edit",
        name: "Chỉnh sửa"
    },
    ACCOUNT_DELETE: {
        key: "Account.Delete",
        name: "Xóa"
    },
    ACCOUNT_SETROLE: {
        key: "Account.SetRole",
        name: "Gán nhóm tài khoản"
    },
    ACCOUNT_SETCLAIM: {
        key: "Account.SetClaim",
        name: "Phân quyền tài khoản"
    },
    ACCOUNT_CHANGEPASSWORD: {
        key: "Account.ChangePassword",
        name: "Đổi mật khẩu"
    },
    ROLE_VIEW: {
        key: "Role.View",
        name: "Xem danh sách"
    },
    ROLE_ADD: {
        key: "Role.Add",
        name: "Thêm mới"
    },
    ROLE_EDIT: {
        key: "Role.Edit",
        name: "Chỉnh sửa"
    },
    ROLE_DELETE: {
        key: "Role.Delete",
        name: "Xóa"
    },
    ROLE_SETCLAIM: {
        key: "Role.SetClaim",
        name: "Phân quyền"
    },
    AUDITLOG_VIEW: {
        key: "AuditLog.View",
        name: "Xem danh sách"
    },
    AUDITLOG_ADD: {
        name: "Thêm",
        key: "AuditLog.Add"
    },
    AUDITLOG_EDIT: {
        name: "Sửa",
        key: "AuditLog.Edit"
    },
    AUDITLOG_DELETE: {
        name: "Xoá",
        key: "AuditLog.Delete"
    },
    PROVINCE_VIEW: {
        key: "Province.View",
        name: "Xem danh sách"
    },
    PROVINCE_ADD: {
        key: "Province.Add",
        name: "Thêm mới"
    },
    PROVINCE_EDIT: {
        key: "Province.Edit",
        name: "Chỉnh sửa"
    },
    PROVINCE_DELETE: {
        key: "Province.Delete",
        name: "Xóa"
    },
    DISTRICT_VIEW: {
        key: "District.View",
        name: "Xem danh sách"
    },
    DISTRICT_ADD: {
        key: "District.Add",
        name: "Thêm mới"
    },
    DISTRICT_EDIT: {
        key: "District.Edit",
        name: "Chỉnh sửa"
    },
    DISTRICT_DELETE: {
        key: "District.Delete",
        name: "Xóa"
    },
    WARD_VIEW: {
        key: "Ward.View",
        name: "Xem danh sách"
    },
    WARD_ADD: {
        key: "Ward.Add",
        name: "Thêm mới"
    },
    WARD_EDIT: {
        key: "Ward.Edit",
        name: "Chỉnh sửa"
    },
    WARD_DELETE: {
        key: "Ward.Delete",
        name: "Xóa"
    },
    WATERFACTORY_VIEW: {
        key: "WaterFactory.View",
        name: "Xem danh sách"
    },
    WATERFACTORY_ADD: {
        key: "WaterFactory.Add",
        name: "Thêm mới"
    },
    WATERFACTORY_EDIT: {
        key: "WaterFactory.Edit",
        name: "Chỉnh sửa"
    },
    WATERFACTORY_DELETE: {
        key: "WaterFactory.Delete",
        name: "Xóa"
    },
    FEELADDER_VIEW: {
        key: "FeeLadder.View",
        name: "Xem danh sách"
    },
    FEELADDER_ADD: {
        key: "FeeLadder.Add",
        name: "Thêm mới"
    },
    FEELADDER_EDIT: {
        key: "FeeLadder.Edit",
        name: "Chỉnh sửa"
    },
    FEELADDER_DELETE: {
        key: "FeeLadder.Delete",
        name: "Xóa"
    },
    FEELADDERLEVEL_VIEW: {
        key: "FeeLadderLevel.View",
        name: "Xem danh sách"
    },
    FEELADDERLEVEL_ADD: {
        key: "FeeLadderLevel.Add",
        name: "Thêm mới"
    },
    FEELADDERLEVEL_EDIT: {
        key: "FeeLadderLevel.Edit",
        name: "Chỉnh sửa"
    },
    FEELADDERLEVEL_DELETE: {
        key: "FeeLadderLevel.Delete",
        name: "Xóa"
    },
    TOLLAREA_VIEW: {
        key: "TollArea.View",
        name: "Xem danh sách"
    },
    TOLLAREA_ADD: {
        key: "TollArea.Add",
        name: "Thêm mới"
    },
    TOLLAREA_EDIT: {
        key: "TollArea.Edit",
        name: "Chỉnh sửa"
    },
    TOLLAREA_DELETE: {
        key: "TollArea.Delete",
        name: "Xóa"
    },
    UNITTYPE_VIEW: {
        key: "UnitType.View",
        name: "Xem danh sách"
    },
    UNITTYPE_ADD: {
        key: "UnitType.Add",
        name: "Thêm mới"
    },
    UNITTYPE_EDIT: {
        key: "UnitType.Edit",
        name: "Chỉnh sửa"
    },
    UNITTYPE_DELETE: {
        key: "UnitType.Delete",
        name: "Xóa"
    },
    WATERUSER_VIEW: {
        key: "WaterUser.View",
        name: "Xem danh sách"
    },
    WATERUSER_ADD: {
        key: "WaterUser.Add",
        name: "Thêm mới"
    },
    WATERUSER_EDIT: {
        key: "WaterUser.Edit",
        name: "Chỉnh sửa"
    },
    WATERUSER_DELETE: {
        key: "WaterUser.Delete",
        name: "Xóa"
    },
    WATERINDEX_VIEW: {
        key: "WaterIndex.View",
        name: "Xem danh sách"
    },
    WATERINDEX_ADD: {
        key: "WaterIndex.Add",
        name: "Thêm mới"
    },
    WATERINDEX_EDIT: {
        key: "WaterIndex.Edit",
        name: "Chỉnh sửa"
    },
    WATERINDEX_DELETE: {
        key: "WaterIndex.Delete",
        name: "Xóa"
    },
    WATERINVOICE_VIEW: {
        key: "WaterInvoice.View",
        name: "Xem danh sách"
    },
    WATERINVOICE_ADD: {
        key: "WaterInvoice.Add",
        name: "Thêm mới"
    },
    WATERINVOICE_EDIT: {
        key: "WaterInvoice.Edit",
        name: "Chỉnh sửa"
    },
    WATERINVOICE_DELETE: {
        key: "WaterInvoice.Delete",
        name: "Xóa"
    },
    WATERINVOICE_DEBTBRICK: {
        key: "WaterInvoice.DebtBrick",
        name: "Gạch nợ hoá đơn"
    },
    WATERINVOICE_EXPORTEINVOICE: {
        key: "WaterInvoice.ExportEInvoice",
        name: "Xuất hóa đơn điện tử"
    },
    READMETER_VIEW: {
        key: "ReadMeter.View",
        name: "Xem danh sách"
    },
    READMETER_ADD: {
        key: "ReadMeter.Add",
        name: "Thêm mới"
    },
    READMETER_EDIT: {
        key: "ReadMeter.Edit",
        name: "Chỉnh sửa"
    },
    READMETER_DELETE: {
        key: "ReadMeter.Delete",
        name: "Xóa"
    },
    USEWATER_VIEW: {
        key: "UseWater.View",
        name: "Xem danh sách"
    },
    USEWATER_ADD: {
        key: "UseWater.Add",
        name: "Thêm mới"
    },
    USEWATER_EDIT: {
        key: "UseWater.Edit",
        name: "Chỉnh sửa"
    },
    USEWATER_DELETE: {
        key: "UseWater.Delete",
        name: "Xóa"
    },
    CONTENT_VIEW: {
        key: "CT.V",
        name: "Xem danh sách"
    },
    CONTENT_ADD: {
        key: "CT.A",
        name: "Thêm mới"
    },
    CONTENT_EDIT: {
        key: "CT.E",
        name: "Chỉnh sửa"
    },
    CONTENT_DELETE: {
        key: "CT.D",
        name: "Xóa"
    },
    SERVICE_VIEW: {
        key: "S.V",
        name: "Xem danh sách"
    },
    SERVICE_ADD: {
        key: "S.A",
        name: "Thêm mới"
    },
    SERVICE_EDIT: {
        key: "S.E",
        name: "Chỉnh sửa"
    },
    SERVICE_DELETE: {
        key: "S.D",
        name: "Xóa"
    },
    SERVICEUSERMANUAL_VIEW: {
        key: "SUM.V",
        name: "Xem danh sách"
    },
    SERVICEUSERMANUAL_ADD: {
        key: "SUM.A",
        name: "Thêm mới"
    },
    SERVICEUSERMANUAL_EDIT: {
        key: "SUM.E",
        name: "Chỉnh sửa"
    },
    SERVICEUSERMANUAL_DELETE: {
        key: "SUM.D",
        name: "Xóa"
    },
    SAMPLETEST_VIEW: {
        key: "ST.V",
        name: "Xem danh sách"
    },
    SAMPLETEST_ADD: {
        key: "ST.A",
        name: "Thêm mới"
    },
    SAMPLETEST_EDIT: {
        key: "ST.E",
        name: "Chỉnh sửa"
    },
    SAMPLETEST_DELETE: {
        key: "ST.D",
        name: "Xóa"
    },
    WATERSUPPLYSUSPENSION_VIEW: {
        key: "SS.V",
        name: "Xem danh sách"
    },
    WATERSUPPLYSUSPENSION_ADD: {
        key: "SS.A",
        name: "Thêm mới"
    },
    WATERSUPPLYSUSPENSION_EDIT: {
        key: "SS.E",
        name: "Chỉnh sửa"
    },
    WATERSUPPLYSUSPENSION_DELETE: {
        key: "SS.D",
        name: "Xóa"
    },
    TRANSACTION_VIEW: {
        key: "T.V",
        name: "Xem danh sách"
    },
    TRANSACTION_ADD: {
        key: "T.A",
        name: "Tạo giao dịch Nhân viên" 
    },
    TRANSACTION_KT: {
        key: "T.KT",
        name: "Tạo giao dịch Kế toán"
    },
    TRANSACTION_EDIT: {
        key: "T.E",
        name: "Chỉnh sửa"
    },
    TRANSACTION_DELETE: {
        key: "T.D",
        name: "Xóa"
    },
    TOPUPTRANSACTION_VIEW: {
        key: "TT.V",
        name: "Xem danh sách"
    },
    TOPUPTRANSACTION_ADD: {
        key: "TT.A",
        name: "Thêm mới"
    },
    TOPUPTRANSACTION_EDIT: {
        key: "TT.E",
        name: "Chỉnh sửa"
    },
    TOPUPTRANSACTION_DELETE: {
        key: "TT.D",
        name: "Xóa"
    },
    USERREQUEST_VIEW: {
        key: "UR.V",
        name: "Xem danh sách"
    },
    USERREQUEST_ADD: {
        key: "UR.A",
        name: "Thêm mới"
    },
    USERREQUEST_EDIT: {
        key: "UR.E",
        name: "Chỉnh sửa"
    },
    USERREQUEST_DELETE: {
        key: "UR.D",
        name: "Xóa"
    },
    USERREQUEST_UPDATE_STATUS: {
        key: "UR.US",
        name: "Cập nhật trạng thái"
    },
    PAYMENTPOINT_VIEW: {
        key: "PaymentPoint.View",
        name: "Xem danh sách"
    },
    PAYMENTPOINT_ADD: {
        key: "PaymentPoint.Add",
        name: "Thêm mới"
    },
    PAYMENTPOINT_EDIT: {
        key: "PaymentPoint.Edit",
        name: "Chỉnh sửa"
    },
    PAYMENTPOINT_DELETE: {
        key: "PaymentPoint.Delete",
        name: "Xóa"
    },
    ELECTRONICCONTRACT_VIEW: {
        key: "ElectronicContract.View",
        name: "Xem danh sách"
    },
    ELECTRONICCONTRACT_ADD: {
        key: "ElectronicContract.Add",
        name: "Thêm mới"
    },
    ELECTRONICCONTRACT_EDIT: {
        key: "ElectronicContract.Edit",
        name: "Chỉnh sửa"
    },
    ELECTRONICCONTRACT_DELETE: {
        key: "ElectronicContract.Delete",
        name: "Xóa"
    },
    ELECTRONICCONTRACT_SIGN: {
        key: "ElectronicContract.Sign",
        name: "Ký hợp đồng"
    },
    NOTIFICATION_VIEW: {
        key: "Notification.View",
        name: "Xem danh sách"
    },
    NOTIFICATION_SEND: {
        key: "Notification.Send",
        name: "Gửi thông báo"
    },
    ARTICLE_VIEW: {
        key: "A.V",
        name: "Xem danh sách"
    },
    ARTICLE_ADD: {
        key: "A.A",
        name: "Thêm mới"
    },
    ARTICLE_EDIT: {
        key: "A.E",
        name: "Chỉnh sửa"
    },
    ARTICLE_DELETE: {
        key: "A.D",
        name: "Xóa"
    },
    DEPARTMENT_VIEW: {
        key: "Department.View",
        name: "Xem danh sách"
    },
    DEPARTMENT_ADD: {
        key: "Department.Add",
        name: "Thêm mới"
    },
    DEPARTMENT_EDIT: {
        key: "Department.Edit",
        name: "Chỉnh sửa"
    },
    DEPARTMENT_DELETE: {
        key: "Department.Delete",
        name: "Xóa"
    },
}

export const ALLOWED_PERMISSIONS = Object.values(PERMISSIONS).map(p => p.key).filter(p => p !== PERMISSIONS.ADMIN.key);

export const PERMISSION_GROUPS = [
    {
      name: "Quản lý tài khoản",
      permissions: [
        PERMISSIONS.ACCOUNT_VIEW,
        PERMISSIONS.ACCOUNT_ADD,
        PERMISSIONS.ACCOUNT_EDIT,
        PERMISSIONS.ACCOUNT_DELETE,
        PERMISSIONS.ACCOUNT_SETROLE,
        PERMISSIONS.ACCOUNT_SETCLAIM,
        PERMISSIONS.ACCOUNT_CHANGEPASSWORD
      ]
    },
    {
      name: "Quản lý nhóm tài khoản",
      permissions: [
        PERMISSIONS.ROLE_VIEW,
        PERMISSIONS.ROLE_ADD,
        PERMISSIONS.ROLE_EDIT,
        PERMISSIONS.ROLE_DELETE,
        PERMISSIONS.ROLE_SETCLAIM
      ]
    },
    {
      name: "Quản lý nhật ký hệ thống",
      permissions: [
        PERMISSIONS.AUDITLOG_VIEW,
        PERMISSIONS.AUDITLOG_ADD,
        PERMISSIONS.AUDITLOG_EDIT,
        PERMISSIONS.AUDITLOG_DELETE
      ]
    },
    {
      name: "Quản lý tin tức",
      permissions: [
        PERMISSIONS.ARTICLE_VIEW,
        PERMISSIONS.ARTICLE_ADD,
        PERMISSIONS.ARTICLE_EDIT,
        PERMISSIONS.ARTICLE_DELETE
      ]
    },
    {
      name: "Quản lý danh mục tỉnh",
      permissions: [
        PERMISSIONS.PROVINCE_VIEW,
        PERMISSIONS.PROVINCE_ADD,
        PERMISSIONS.PROVINCE_EDIT,
        PERMISSIONS.PROVINCE_DELETE
      ]
    },
    {
      name: "Quản lý danh mục huyện",
      permissions: [
        PERMISSIONS.DISTRICT_VIEW,
        PERMISSIONS.DISTRICT_ADD,
        PERMISSIONS.DISTRICT_EDIT,
        PERMISSIONS.DISTRICT_DELETE
      ]
    },
    {
      name: "Quản lý danh mục xã",
      permissions: [
        PERMISSIONS.WARD_VIEW,
        PERMISSIONS.WARD_ADD,
        PERMISSIONS.WARD_EDIT,
        PERMISSIONS.WARD_DELETE
      ]
    },
    {
      name: "Quản lý danh sách nhà máy",
      permissions: [
        PERMISSIONS.WATERFACTORY_VIEW,
        PERMISSIONS.WATERFACTORY_ADD,
        PERMISSIONS.WATERFACTORY_EDIT,
        PERMISSIONS.WATERFACTORY_DELETE
      ]
    },
    {
      name: "Quản lý danh sách bảng phí",
      permissions: [
        PERMISSIONS.FEELADDER_VIEW,
        PERMISSIONS.FEELADDER_ADD,
        PERMISSIONS.FEELADDER_EDIT,
        PERMISSIONS.FEELADDER_DELETE
      ]
    },
    {
      name: "Quản lý danh sách bảng phí chi tiết",
      permissions: [
        PERMISSIONS.FEELADDERLEVEL_VIEW,
        PERMISSIONS.FEELADDERLEVEL_ADD,
        PERMISSIONS.FEELADDERLEVEL_EDIT,
        PERMISSIONS.FEELADDERLEVEL_DELETE
      ]
    },
    {
      name: "Quản lý khu vực thu phí",
      permissions: [
        PERMISSIONS.TOLLAREA_VIEW,
        PERMISSIONS.TOLLAREA_ADD,
        PERMISSIONS.TOLLAREA_EDIT,
        PERMISSIONS.TOLLAREA_DELETE
      ]
    },
    {
      name: "Quản lý loại hình đơn vị",
      permissions: [
        PERMISSIONS.UNITTYPE_VIEW,
        PERMISSIONS.UNITTYPE_ADD,
        PERMISSIONS.UNITTYPE_EDIT,
        PERMISSIONS.UNITTYPE_DELETE
      ]
    },
    {
      name: "Quản lý danh mục phòng ban",
      permissions: [
        PERMISSIONS.DEPARTMENT_VIEW,
        PERMISSIONS.DEPARTMENT_ADD,
        PERMISSIONS.DEPARTMENT_EDIT,
        PERMISSIONS.DEPARTMENT_DELETE
      ]  
    },
    {
      name: "Quản lý hộ sử dụng nước",
      permissions: [
        PERMISSIONS.WATERUSER_VIEW,
        PERMISSIONS.WATERUSER_ADD,
        PERMISSIONS.WATERUSER_EDIT,
        PERMISSIONS.WATERUSER_DELETE
      ]
    },
    {
      name: "Quản lý chỉ số nước",
      permissions: [
        PERMISSIONS.WATERINDEX_VIEW,
        PERMISSIONS.WATERINDEX_ADD,
        PERMISSIONS.WATERINDEX_EDIT,
        PERMISSIONS.WATERINDEX_DELETE
      ]
    },
    {
      name: "Quản lý hóa đơn nước",
      permissions: [
        PERMISSIONS.WATERINVOICE_VIEW,
        PERMISSIONS.WATERINVOICE_ADD,
        PERMISSIONS.WATERINVOICE_EDIT,
        PERMISSIONS.WATERINVOICE_DELETE,
        PERMISSIONS.WATERINVOICE_DEBTBRICK,
        PERMISSIONS.WATERINVOICE_EXPORTEINVOICE
      ]
    },
    {
      name: "Lịch đọc số nước",
      permissions: [
        PERMISSIONS.READMETER_VIEW,
        PERMISSIONS.READMETER_ADD,
        PERMISSIONS.READMETER_EDIT,
        PERMISSIONS.READMETER_DELETE
      ]
    },
    {
      name: "Yêu cầu đăng ký sử dụng nước",
      permissions: [
        PERMISSIONS.USEWATER_VIEW,
        PERMISSIONS.USEWATER_ADD,
        PERMISSIONS.USEWATER_EDIT,
        PERMISSIONS.USEWATER_DELETE
      ]
    },
    {
      name: "Quản lý nội dung website",
      permissions: [
        PERMISSIONS.CONTENT_VIEW,
        PERMISSIONS.CONTENT_ADD,
        PERMISSIONS.CONTENT_EDIT,
        PERMISSIONS.CONTENT_DELETE
      ]
    },
    {
      name: "Quản lý dịch vụ",
      permissions: [
        PERMISSIONS.SERVICE_VIEW,
        PERMISSIONS.SERVICE_ADD,
        PERMISSIONS.SERVICE_EDIT,
        PERMISSIONS.SERVICE_DELETE
      ]
    },
    {
      name: "Quản lý hướng dẫn dịch vụ",
      permissions: [
        PERMISSIONS.SERVICEUSERMANUAL_VIEW,
        PERMISSIONS.SERVICEUSERMANUAL_ADD,
        PERMISSIONS.SERVICEUSERMANUAL_EDIT,
        PERMISSIONS.SERVICEUSERMANUAL_DELETE
      ]
    },
    {
      name: "Quản lý chất lượng nước",
      permissions: [
        PERMISSIONS.SAMPLETEST_VIEW,
        PERMISSIONS.SAMPLETEST_ADD,
        PERMISSIONS.SAMPLETEST_EDIT,
        PERMISSIONS.SAMPLETEST_DELETE
      ]
    },
    {
      name: "Quản lý lịch ngưng cấp nước",
      permissions: [
        PERMISSIONS.WATERSUPPLYSUSPENSION_VIEW,
        PERMISSIONS.WATERSUPPLYSUSPENSION_ADD,
        PERMISSIONS.WATERSUPPLYSUSPENSION_EDIT,
        PERMISSIONS.WATERSUPPLYSUSPENSION_DELETE
      ]
    },
    {
      name: "Quản lý lịch sử giao dịch",
      permissions: [
        PERMISSIONS.TRANSACTION_VIEW,
        PERMISSIONS.TRANSACTION_ADD,
        PERMISSIONS.TRANSACTION_KT,
        PERMISSIONS.TRANSACTION_EDIT,
        PERMISSIONS.TRANSACTION_DELETE
      ]
    },
    {
      name: "Quản lý lịch sử nộp tiền",
      permissions: [
        PERMISSIONS.TOPUPTRANSACTION_VIEW,
        PERMISSIONS.TOPUPTRANSACTION_ADD,
        PERMISSIONS.TOPUPTRANSACTION_EDIT,
        PERMISSIONS.TOPUPTRANSACTION_DELETE
      ]
    },
    {
      name: "Quản lý yêu cầu khách hàng",
      permissions: [
        PERMISSIONS.USERREQUEST_VIEW,
        PERMISSIONS.USERREQUEST_ADD,
        PERMISSIONS.USERREQUEST_EDIT,
        PERMISSIONS.USERREQUEST_DELETE
      ]
    },
    {
      name: "Gửi thông báo khách hàng",
      permissions: [
        PERMISSIONS.NOTIFICATION_VIEW,
        PERMISSIONS.NOTIFICATION_SEND
      ]
    },
    {
      name: "Quản lý điểm thanh toán",
      permissions: [
        PERMISSIONS.PAYMENTPOINT_VIEW,
        PERMISSIONS.PAYMENTPOINT_ADD,
        PERMISSIONS.PAYMENTPOINT_EDIT,
        PERMISSIONS.PAYMENTPOINT_DELETE
      ]
    },
    {
      name: "Quản lý hợp đồng điện tử",
      permissions: [
        PERMISSIONS.ELECTRONICCONTRACT_VIEW,
        PERMISSIONS.ELECTRONICCONTRACT_ADD,
        PERMISSIONS.ELECTRONICCONTRACT_EDIT,
        PERMISSIONS.ELECTRONICCONTRACT_DELETE,
        PERMISSIONS.ELECTRONICCONTRACT_SIGN
      ]
    }
];

export interface PermissionClaim {
    id: string;
    group?: string;
    checked: boolean;
    name: string;
}
  
export interface PagePermission {
    view: boolean,
    add: boolean,
    edit: boolean,
    delete: boolean
}

